import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import { useStoreState } from 'base/store';
import styles from './index.module.less';
import { get750RemValue } from 'base/utils/dom-size';

type IconCheckProps = HTMLAttributes<HTMLDivElement> & {
    size: [number, number] | number;
    color?: string;
    bgColor?: string;
}

const STANDARD_SIZE = 44;

const IconCheck: React.FC<IconCheckProps> = props => {
    const {
        size: propsSize,
        className,
        style,
        bgColor,
        color,
        ...rest
    } = props;
    const { ua: { isPhone } } = useStoreState('rootStore');
    const size = isPhone
        ? (typeof propsSize === 'number' ? propsSize : propsSize[0]) / 2
        : typeof propsSize === 'number' ? propsSize : propsSize[1];

    const sizeWithUnit = isPhone ? get750RemValue(size * 2) : `${size}px`
    const scaleValue = Math.floor((size / STANDARD_SIZE) * 100) / 100;

    return (
        <div
            {...rest}
            className={cn(className, styles.wrapper)}
            style={{
                width: sizeWithUnit,
                height: sizeWithUnit
            }}
        >
            <div className="bg" style={{
                transform: `scale(${scaleValue})`,
                backgroundColor: bgColor
            }}>
                <div className="check" style={{ borderColor: color }}/>
            </div>
        </div>
    );
};

export default IconCheck;